import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

/**
 * Base class for form cell renderers that include form controls.
 */
@Component({
    selector: 'app-form-cell-renderer-base',
    changeDetection: ChangeDetectionStrategy.Eager,
    template:
        '<!-- This component serves as a base and does not render any content -->',
})
export abstract class FormCellRendererBaseComponent<
    T extends ICellRendererParams,
> implements ICellRendererAngularComp
{
    params: T = {} as T;
    formControl: FormControl = new FormControl();
    isFocusedState = signal(false);

    abstract agInit(_: T): void;

    refresh(): boolean {
        return true;
    }

    updateIsFocusedState(value: boolean): void {
        this.isFocusedState.set(value);
    }

    shouldFocus(): boolean {
        return this.isFocusedState().valueOf() !== true;
    }

    abstract onFocus(): void;
}
